export const createBrandModelPair = (brand: string, model: string) =>
  `${brand}-${model}`;
